import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { Results } from '@local/client-contracts';
import { decode } from 'html-entities';
import { isEqual } from 'lodash';
import { ResultMarkdownService } from 'src/app/bar/services/result-markdown.service';

@Component({
  selector: 'result-markdown-block',
  templateUrl: './result-markdown-block.component.html',
  styleUrls: ['./result-markdown-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultMarkdownBlockComponent {
  private _model: Results.MarkdownBlock;
  private _highlights: Array<string> = [];
  private readonly TEXT_BETWEEN_TAGS_RGX = new RegExp(/>([^<]*)</, 'gi');
  text: string;

  @Input() set model(model: Results.MarkdownBlock) {
    if (this.model?.content && model?.content && isEqual(this.model.content, model.content)) {
      return;
    }
    this._model = model;
    this.initData();
  }

  @Input() set highlights(value: Array<string>) {
    this._highlights = value;
    this.initData();
  }

  constructor(private cdr: ChangeDetectorRef, private resultMarkdownService: ResultMarkdownService) {}

  private replace(text: string, word: string): string {
    return text.replace(this.TEXT_BETWEEN_TAGS_RGX, (match) => {
      const regex = new RegExp(word, 'gi');
      const newText = decode(match, { level: 'all' });
      return newText.replace(regex, (match: string) => {
        return `<mark class="text-highlight">${match}</mark>`;
      });
    });
  }
  private initData() {
    let text = this.resultMarkdownService.render(this._model.content);

    if (this._highlights?.length) {
      this._highlights.forEach((word) => {
        text = this.replace(text, word);
      });
    }
    this.text = text;
    this.cdr.markForCheck();
  }
}
